import { Mail, Phone } from "lucide-react";
import { COMPANY } from "@/content/site";
import { Reveal, MaskLine } from "./Reveal";
import { SectionHead } from "./Bits";
import ContactForm from "./ContactForm";

export default function Contact() {
  return (
    <section id="contacto" data-testid="contact-section" className="bg-[#F6F4EF] py-24 sm:py-32">
      <div className="container-x grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal><SectionHead index="05" eyebrow="Contacto" /></Reveal>
          <h2 className="mt-6 font-display text-3xl font-light uppercase leading-[1.08] text-[#1E2228] sm:text-5xl">
            <MaskLine inView>Cuéntanos</MaskLine>
            <MaskLine inView delay={0.1}>tu <span className="font-serif-it normal-case text-[#8A6C3E]">proyecto</span></MaskLine>
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-[#3A414B] sm:text-lg">
              Llámanos, escríbenos o rellena el formulario y cuéntanos qué necesitas. Te contestaremos para conocer tu idea y valorar tu proyecto.
            </p>
            <dl className="mt-10 space-y-6 border-t border-[#1E2228]/15 pt-8">
              <div>
                <dt className="eyebrow text-[#8A6C3E]">Teléfono</dt>
                <dd><a href={COMPANY.phoneHref} data-testid="contact-phone-link" className="link-underline mt-2 inline-block font-display text-2xl font-light text-[#1E2228] sm:text-3xl">{COMPANY.phone}</a></dd>
              </div>
              <div>
                <dt className="eyebrow text-[#8A6C3E]">Correo electrónico</dt>
                <dd><a href={COMPANY.emailHref} data-testid="contact-email-link" className="link-underline mt-2 inline-block break-all font-display text-lg font-light text-[#1E2228] sm:text-xl">{COMPANY.email}</a></dd>
              </div>
            </dl>
            <div className="mt-10 flex flex-col gap-3 sm:flex-row">
              <a href={COMPANY.phoneHref} data-testid="contact-call-button" className="btn-gold"><Phone className="h-4 w-4" />Llamar ahora</a>
              <a href={COMPANY.emailHref} data-testid="contact-mail-button" className="btn-outline-dark"><Mail className="h-4 w-4" />Enviar un correo</a>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="relative bg-white p-6 shadow-[0_40px_80px_-50px_rgba(30,34,40,0.35)] sm:p-10 lg:col-span-7 lg:p-14">
          <span className="absolute left-0 top-0 h-1 w-24 bg-[#B8955F]" />
          <h3 className="mb-8 font-display text-lg font-semibold uppercase tracking-[0.14em] text-[#1E2228]">Solicitar presupuesto</h3>
          <ContactForm />
        </Reveal>
      </div>
    </section>
  );
}
